import { render, staticRenderFns } from "./BucketList.vue?vue&type=template&id=d9d15352&"
import script from "./BucketList.vue?vue&type=script&lang=js&"
export * from "./BucketList.vue?vue&type=script&lang=js&"
import style0 from "./BucketList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports